
const RecipeInstructions = () => {
  return (
    <>
      <h2 className="text-2xl font-medium mb-4">Step-by-Step Instructions</h2>
      
      <div className="space-y-8 mb-8">
        <div>
          <h3 className="text-xl font-medium mb-2">1. Prepare Your Fortunes</h3>
          <p className="text-muted-foreground mb-4">
            Before you begin making the batter, write your fortunes on small strips of paper (approximately 3" × ½"). Keep them aside in a clean, dry place. You can write traditional fortunes, personalized messages, jokes, or even create themed fortunes for special occasions.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium mb-2">2. Preheat and Prepare</h3>
          <p className="text-muted-foreground mb-4">
            Preheat your oven to 350°F (175°C). Line a baking sheet with a silicone baking mat or parchment paper. If using parchment, lightly spray it with non-stick cooking spray.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium mb-2">3. Make the Batter</h3>
          <p className="text-muted-foreground mb-4">
            In a medium bowl, whisk the egg whites, sugar, and salt until frothy but not stiff. Add the melted butter, vanilla extract, and almond extract (if using), then whisk until well combined. Gradually add the flour, whisking constantly to avoid lumps. Add the water and mix until you have a smooth, thin batter that's similar to pancake batter.
          </p>
          <div className="bg-muted p-4 rounded-lg text-muted-foreground">
            <p className="font-medium text-foreground">Pro Tip:</p> 
            <p>Let the batter rest for 30 minutes at room temperature. This allows the flour to fully hydrate and will give you more consistent results.</p>
          </div>
        </div>

        <div>
          <h3 className="text-xl font-medium mb-2">4. Bake in Small Batches</h3>
          <p className="text-muted-foreground mb-4">
            Using a round cookie cutter or glass as a guide, trace 3-inch circles on your baking mat or parchment paper. For beginners, start with just 2-3 cookies per batch as you'll need to shape them quickly while they're hot.
          </p>
          <p className="text-muted-foreground mb-4">
            Spoon 1 tablespoon of batter onto each circle and use the back of the spoon to spread it evenly into a thin layer. Be sure the batter is spread uniformly for even baking.
          </p>
          <p className="text-muted-foreground mb-4">
            Bake for 5-7 minutes, or until the edges are golden brown and the centers are just beginning to brown. The cookies should be pliable but set.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium mb-2">5. Shape Quickly</h3>
          <p className="text-muted-foreground mb-4">
            Working quickly (the cookies harden fast!), remove one cookie from the oven with a thin spatula. Place a fortune in the center of the cookie, then fold the cookie in half to create a semi-circle. Quickly bring the pointed edges together by folding the cookie over the edge of a mug or bowl, creating the characteristic fortune cookie shape.
          </p>
          <p className="text-muted-foreground mb-4">
            Place the shaped cookie in a muffin tin to help it hold its shape as it cools. Repeat with the remaining cookies on the sheet.
          </p>
          <div className="bg-muted p-4 rounded-lg text-muted-foreground">
            <p className="font-medium text-foreground">Pro Tip:</p> 
            <p>Wear heat-resistant gloves as the cookies will be very hot. If a cookie becomes too firm to shape, return it to the oven for 10-15 seconds to soften.</p>
          </div>
        </div>

        <div>
          <h3 className="text-xl font-medium mb-2">6. Cool and Store</h3>
          <p className="text-muted-foreground mb-4">
            Allow the cookies to cool completely in the muffin tin, which will take about 5 minutes. Once cooled, they should be crisp and hold their shape. Store in an airtight container for up to 5 days.
          </p>
        </div>
      </div>
    </>
  );
};

export default RecipeInstructions;
